// export const baseUrl="https://13.60.128.213/api/"
// export const baseUrl="https://contract-assist.somee.com/api/"
// export const baseUrl="https://localhost:7133/api/"
export const baseUrl="https://backendforrailway-production.up.railway.app/api/"
export const externalApiUrl="https://legalseefastapi-production-d64d.up.railway.app/api/"